function Test() {
  return (
    <div className="w-full min-h-[calc(100vh_-_30rem)] p-4">
      <h1 className="text-2xl font-medium mb-4">Dev/Test Component</h1>
    </div>
  )
}

export default Test
